<template>
    <div>
        <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item>
                        <el-select @change="changeInstituicao" v-model="filtro.instituicao.id" filterable placeholder="Pesquisar Instituição">
                            <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <el-row class="u-mt-10 u-mb-20">
            <el-col :xs="24" :sm="24" :md="24">
                <el-input v-model="filtro['usuario_id']" placeholder="Usuário ID (opcional)" @keyup.native.enter="loadingEmprestimos"></el-input>
            </el-col>            
        </el-row>

        <el-row :gutter="10" class="u-mb-10">
            <el-col :xs="24" :sm="8" :md="8">
                <el-select v-model="filtro['usuario_tipo']" placeholder="Tipo de usuário" clearable @change="loadingEmprestimos" style="width: 100%;">
                    <el-option label="ALUNO" value="aluno"></el-option>
                    <el-option label="SERVIDOR" value="servidor"></el-option>
                    <el-option label="FUNCIONÁRIO" value="funcionario"></el-option>
                </el-select>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8">
                <el-input v-model="filtro['livro_id']" placeholder="Livro ID (opcional)" @keyup.native.enter="loadingEmprestimos"></el-input>
            </el-col>
            <el-col :xs="24" :sm="4" :md="4">
                <el-select v-model="filtro['aberto']" placeholder="Situação" @change="loadingEmprestimos" style="width: 100%;">
                    <el-option label="Todos" :value="null"></el-option>
                    <el-option label="Em aberto" :value="true"></el-option>
                    <el-option label="Devolvidos" :value="false"></el-option>
                </el-select>
            </el-col>
            <el-col :xs="24" :sm="4" :md="4" class="u-text-right">
                <el-button type="primary" @click="abrirCadastro">NOVO EMPRÉSTIMO</el-button>
            </el-col>
        </el-row>

        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th class="hidden-mobile" style="width: 70px;">cod</th>
                        <th>Livro</th>
                        <th class="hidden-mobile">Exemplar</th>
                        <th class="hidden-mobile">Usuário</th>
                        <th class="hidden-mobile u-text-center" style="width: 110px;">Empr.</th>
                        <th class="hidden-mobile u-text-center" style="width: 110px;">Prev.</th>
                        <th class="hidden-mobile u-text-center" style="width: 110px;">Dev.</th>
                        <th class="u-text-center" style="width: 110px;">Situação</th>
                        <th class="u-text-center" style="width: 200px;">Ação</th>
                    </tr>
                </thead>
                <tbody v-if="statusList">
                    <tr v-for="item in items" :key="item.id">
                        <td class="hidden-mobile">{{ item.id }}</td>
                        <td>{{ (item.exemplar && item.exemplar.livro) ? item.exemplar.livro.titulo : '-' }}</td>
                        <td class="hidden-mobile">{{ (item.exemplar) ? item.exemplar.codigo : '-' }}</td>
                        <td class="hidden-mobile">
                            {{ item.usuario_nome ? item.usuario_nome : '#' + item.usuario_id }}
                            <small class="u-text-muted">({{ (item.usuario_tipo || '').toUpperCase() }})</small>
                        </td>
                        <td class="hidden-mobile u-text-center">{{ formatDate(item.data_emprestimo) }}</td>
                        <td class="hidden-mobile u-text-center">
                            <span :style="{ color: isAtrasado(item) ? '#d9534f' : 'inherit' }">
                                {{ formatDate(item.data_prevista_devolucao) }}
                            </span>
                        </td>
                        <td class="hidden-mobile u-text-center">{{ item.data_devolucao ? formatDate(item.data_devolucao) : '-' }}</td>
                        <td class="u-text-center">
                            <el-tag v-if="item.data_devolucao" type="success" size="mini">Devolvido</el-tag>
                            <el-tag v-else-if="isAtrasado(item)" type="danger" size="mini">Atrasado</el-tag>
                            <el-tag v-else type="warning" size="mini">Em aberto</el-tag>
                        </td>
                        <td class="u-text-center acao">
                            <el-button
                                @click="openDialogDevolver(item)"
                                :disabled="!!item.data_devolucao"
                                type="warning"
                                icon="el-icon-check"
                                size="mini"
                                plain>
                                Devolver
                            </el-button>
                            <el-button
                                @click="openDialogRenovar(item)"
                                :disabled="!!item.data_devolucao"
                                type="info"
                                icon="el-icon-refresh"
                                size="mini"
                                plain
                                title="Renovar prazo">
                                Renovar
                            </el-button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
            <el-row :gutter="10" v-if="statusList">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                        <el-pagination :current-page='paginate.page' class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                    </div>
                </el-col>
            </el-row>
        </div>

        <el-dialog :close-on-click-modal="false" title="DEVOLUÇÃO" width="70%" top="5vh" :visible.sync="dialogDevolver">
            <div class="main">
                <el-form @submit.native.prevent="onSubmitDevolver" :model="formDevolver" ref="formDevolver" label-position="top">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Data de devolução" prop="data_devolucao" :rules="[$requiredChange]" key="data_devolucao">
                                <el-date-picker v-model="formDevolver.data_devolucao" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Estado do exemplar" prop="estado_devolucao" :rules="[$requiredChange]" key="estado_devolucao">
                                <el-select v-model="formDevolver.estado_devolucao">
                                    <el-option label="DISPONÍVEL" value="disponivel"></el-option>
                                    <el-option label="DANIFICADO" value="danificado"></el-option>
                                    <el-option label="PERDIDO" value="perdido"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Multa (R$)" prop="multa_valor" key="multa_valor">
                                <el-input v-model="formDevolver.multa_valor"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-form-item label="Observação" prop="observacao" key="observacao">
                                <el-input type="textarea" :rows="3" v-model="formDevolver.observacao"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-form-item class="u-text-right u-mt-15">
                                <el-button type="primary" id="btn-devolver" native-type="submit">SALVAR</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="RENOVAR EMPRÉSTIMO" width="450px" :visible.sync="dialogRenovar">
            <div v-if="emprestimoRenovar" class="u-mb-15">
                <p><strong>Livro:</strong> {{ (emprestimoRenovar.exemplar && emprestimoRenovar.exemplar.livro) ? emprestimoRenovar.exemplar.livro.titulo : '-' }}</p>
                <p><strong>Data prevista atual:</strong> {{ formatDate(emprestimoRenovar.data_prevista_devolucao) }}</p>
                <p><strong>Renovações realizadas:</strong> {{ emprestimoRenovar.qtd_renovacoes || 0 }}</p>
            </div>
            <el-form @submit.native.prevent="onSubmitRenovar" :model="formRenovar" ref="formRenovar" label-position="top">
                <el-form-item label="Nova data prevista" prop="data_prevista_devolucao" :rules="[$requiredChange]">
                    <el-date-picker v-model="formRenovar.data_prevista_devolucao" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                </el-form-item>
                <el-form-item class="u-text-right">
                    <el-button @click="dialogRenovar = false" plain>Cancelar</el-button>
                    <el-button type="primary" id="btn-renovar" native-type="submit">CONFIRMAR RENOVAÇÃO</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data: () => ({
        statusList: false,
        filtro: {
            usuario_tipo: '',
            usuario_id: '',
            livro_id: '',
            aberto: true,
            instituicao_id: '',
            instituicao: { id: '', nome: '' }
        },
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        items: [],
        dialogDevolver: false,
        emprestimoSelected: null,
        formDevolver: {
            data_devolucao: '',
            estado_devolucao: 'disponivel',
            multa_valor: '',
            observacao: ''
        },
        dialogRenovar: false,
        emprestimoRenovar: null,
        formRenovar: {
            data_prevista_devolucao: ''
        }
    }),
    computed: {
        exibeSelectInstituicao(){
            const t = Number(this.$store.state.user.tipo);
            return (t > 3 && t <= 8) || t === 10;
        }
    },
    mounted () {
        if(this.$store.state.config.instituicao){
            this.filtro.instituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome };
        }
        this.loadingEmprestimos();
    },
    methods: {
        abrirCadastro(){
            if(!this.$store.state.config.instituicao || !this.$store.state.config.instituicao.id){
                window.eventBus.$emit('alert', {msg: 'Selecione uma instituição antes de cadastrar um empréstimo.', type: 'warning'});
                return;
            }
            this.$router.push({
                path: '/admin/biblioteca/emprestimo/cadastro',
                query: { instituicao_id: this.$store.state.config.instituicao.id }
            });
        },
        async changeInstituicao(){
            if(this.exibeSelectInstituicao){
                await this.$store.dispatch('setInstituicao', this.filtro.instituicao.id);
            }
            this.paginate.page = 1;
            this.loadingEmprestimos();
        },
        loadingEmprestimos(){
            this.statusList = false;
            this.items = [];
            this.filtro.instituicao_id = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : '';

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/emprestimo/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth).then(response => {
                this.items = response.data.data;
                this.paginate.qtdItens = response.data.total;
                this.paginate.from = response.data.from;
                this.paginate.to = response.data.to;
                this.statusList = true;
            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        getPagePagination(page){
            this.paginate.page = page;
            this.loadingEmprestimos();
        },
        toISODate(d){
            if(!d) return null;
            const s = String(d).trim();
            // já está em pt-BR
            if(/^\d{2}\/\d{2}\/\d{4}$/.test(s)) return null;
            // pega YYYY-MM-DD mesmo que venha com hora (YYYY-MM-DD HH:mm:ss) ou ISO (YYYY-MM-DDTHH:mm:ss)
            const m = s.match(/(\d{4})-(\d{2})-(\d{2})/);
            if(!m) return null;
            return `${m[1]}-${m[2]}-${m[3]}`;
        },
        formatDate(d){
            if(!d) return '';
            const s = String(d).trim();
            if(/^\d{2}\/\d{2}\/\d{4}$/.test(s)) return s;

            const iso = this.toISODate(s);
            if(!iso) return s;

            const parts = iso.split('-'); // yyyy-mm-dd
            return `${parts[2]}/${parts[1]}/${parts[0]}`;
        },
        isAtrasado(item){
            if(item.data_devolucao) return false;
            if(!item.data_prevista_devolucao) return false;
            const today = new Date();
            const iso = this.toISODate(item.data_prevista_devolucao);
            const prev = new Date((iso || item.data_prevista_devolucao) + 'T00:00:00');
            return today > prev;
        },
        openDialogDevolver(item){
            this.emprestimoSelected = item;
            this.formDevolver = {
                data_devolucao: new Date().toISOString().slice(0,10),
                estado_devolucao: 'disponivel',
                multa_valor: '',
                observacao: ''
            };
            this.dialogDevolver = true;
        },
        onSubmitDevolver(){
            document.getElementById("btn-devolver").focus();

            this.$refs.formDevolver.validate((valid) =>{ if(valid){
                window.eventBus.$emit('loading', true);

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/emprestimo/devolver/` + this.emprestimoSelected.id, this.formDevolver, this.$store.getters.getHeaderAuth).then((response) => {
                    window.eventBus.$emit('loading', false);
                    if(response.data && response.data.erro){
                        const msg = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Não foi possível registrar a devolução.');
                        window.eventBus.$emit('alert', {msg, type: 'warning'});
                        return;
                    }
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.dialogDevolver = false;
                    this.loadingEmprestimos();
                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        openDialogRenovar(item){
            this.emprestimoRenovar = item;
            this.formRenovar = { data_prevista_devolucao: '' };
            this.dialogRenovar = true;
        },
        onSubmitRenovar(){
            document.getElementById("btn-renovar").focus();
            this.$refs.formRenovar.validate((valid) => { if(valid){
                window.eventBus.$emit('loading', true);
                this.$axios.post(
                    `${this.$store.state.config.baseUrlApi}/api/biblioteca/emprestimo/renovar/` + this.emprestimoRenovar.id,
                    this.formRenovar,
                    this.$store.getters.getHeaderAuth
                ).then((response) => {
                    window.eventBus.$emit('loading', false);
                    if(response.data && response.data.erro){
                        const msg = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Não foi possível renovar o empréstimo.');
                        window.eventBus.$emit('alert', {msg, type: 'warning'});
                        return;
                    }
                    window.eventBus.$emit('alert', {msg: 'Empréstimo renovado com sucesso.', type: 'success'});
                    this.dialogRenovar = false;
                    this.loadingEmprestimos();
                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
            }});
        }
    }
}
</script>

